import { useEffect } from 'react';
import { MEDIA_FRONTEND_URL } from '@src/configs';

const FontLoader = () => {
  useEffect(() => {
    const fontUrl = MEDIA_FRONTEND_URL;

    if (fontUrl) {
      const style = document.createElement('style');
      style.innerHTML = `
        /* SF Pro2 */
        @font-face {
          font-family: 'SF Pro Text';
          src: url(${fontUrl}/fonts/SFProText-Light.woff2);
          font-weight: 300;
        }
        @font-face {
          font-family: 'SF Pro Text';
          src: url(${fontUrl}/fonts/SFProText-Regular.woff2);
          font-weight: 400;
        }
        @font-face {
          font-family: 'SF Pro Text';
          src: url(${fontUrl}/fonts/SFProText-Medium.woff2);
          font-weight: 500;
        }
        @font-face {
          font-family: 'SF Pro Text';
          src: url(${fontUrl}/fonts/SFProText-Semibold.woff2);
          font-weight: 600;
        }
        @font-face {
          font-family: 'SF Pro Text';
          src: url(${fontUrl}/fonts/SFProText-Bold.woff2);
          font-weight: 700;
        }
        @font-face {
          font-family: 'SF Pro Text';
          src: url(${fontUrl}/fonts/SFProText-Black.woff2);
          font-weight: 800;
        }
        @font-face {
          font-family: 'SF Pro Text';
          src: url(${fontUrl}/fonts/SFProText-Heavy.woff2);
          font-weight: 900;
        }

        /* SF Pro Italic2 */
        @font-face {
          font-family: 'SF Pro Italic';
          src: url(${fontUrl}/fonts/SFProText-LightItalic.woff2);
          font-weight: 300;
        }
        @font-face {
          font-family: 'SF Pro Italic';
          src: url(${fontUrl}/fonts/SFProText-RegularItalic.woff2);
          font-weight: 400;
        }
        @font-face {
          font-family: 'SF Pro Italic';
          src: url(${fontUrl}/fonts/SFProText-MediumItalic.woff2);
          font-weight: 500;
        }
        @font-face {
          font-family: 'SF Pro Italic';
          src: url(${fontUrl}/fonts/SFProText-SemiboldItalic.woff2);
          font-weight: 600;
        }
        @font-face {
          font-family: 'SF Pro Italic';
          src: url(${fontUrl}/fonts/SFProText-BoldItalic.woff2);
          font-weight: 700;
        }
        @font-face {
          font-family: 'SF Pro Italic';
          src: url(${fontUrl}/fonts/SFProText-BlackItalic.woff2);
          font-weight: 800;
        }
        @font-face {
          font-family: 'SF Pro Italic';
          src: url(${fontUrl}/fonts/SFProText-HeavyItalic.woff2);
          font-weight: 900;
        }
      `;

      document.head.appendChild(style);
    }
  }, []);

  return null;
};

export default FontLoader;
